<template>
  <div class="checkout-summary checkout-summary-size">
    <div class="cart-summary-box">
      <div>
        <table class="summary-cart rounded-br-none rounded-bl-none">
          <thead>
          <tr class="font-bold">
            <th class="text-black opacity-100" colspan="3">
              <div class="flex justify-between">
                <div class="w-2/4 lg:w-full xl:w-full">
                  <h3>
                    <icon name="shopping-cart"></icon>
                    Dein Warenkorb
                  </h3>
                </div>
                <div class="w-2/4 lg:hidden xl:hidden">
                  <button @click.prevent="openedDetails = !openedDetails" class="btn icon black outline"><span><icon
                      class="icon"
                      :name="openedDetails ? 'caret-up' : 'caret-down'"></icon></span><span>{{ openedDetails ? 'Weniger' : 'Details' }}</span>
                  </button>
                </div>
              </div>
            </th>
          </tr>
          <tr v-show="openedDetails" >
            <th>Artikel</th>
            <th>Menge</th>
            <th>Preis</th>
          </tr>
          </thead>
        </table>
        <div v-show="openedDetails" class="overscroll-wrapper">
          <table class="summary-cart rounded-br-none rounded-bl-none">
            <tbody>
            <tr v-for="item in cart.cartItems.data" >
              <td>{{ item.name }}</td>
              <td>{{ getTextFromUnit(item.unit) }}</td>
              <td>{{ formatPrice(item, 'bruttoSum') }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <table>
          <tbody v-show="openedDetails" >
          <tr>
            <td colspan="2">Zwischensumme <span>(inkl. MwSt)</span></td>
            <td>{{ cart ? totalPriceFormat(cart) : '--' }}</td>
          </tr>
          <tr class="light-color">
            <td colspan="2">Versand & Verpackung</td>
            <td>{{ finalCarrier.uid ? getCarrierText() : '--' }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="2">Insgesamt</td>
            <td>{{ finalCarrier.uid ? totalPriceCheckoutFormat(cart, finalCarrier) : '--' }}</td>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'checkoutSummary',
    props: {},
    data () {
      return {
        agbCheck: false,
        anotherCheck: false,
        openedDetails: true
      }
    },
    mixins: [formatting],
    methods: {
      ...mapActions([
      ]),
      getAddressText (address) {
        return address.street + ' ' + address.number
      },
      getPaymentText (pm) {
        return pm.card_brand + ' endet auf ' + pm.card_last4
      },
      getCarrierText () {
        return this.finalCarrier.name + ': ' + this.totalCarrierPrice(this.cart, this.finalCarrier)
      }
    },
    computed: {
      ...mapGetters({
        cart: 'checkout_get_cart',
        loading: 'options_is_loading',
        finalDeliveryAddress: 'checkout_get_address',
        finalInvoiceAddress: 'checkout_get_invoice_address',
        finalPaymentMethod: 'checkout_get_paymentMethod',
        finalCarrier: 'checkout_get_carrier'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/checkoutSummary.vue